import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from '@/features/auth/AuthContext';
import '@/style/index.scss';
import { jsx as _jsx } from "react/jsx-runtime";
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/ _jsx(React.StrictMode, {
    children: /*#__PURE__*/ _jsx(HashRouter, {
        children: /*#__PURE__*/ _jsx(AuthProvider, {
            children: /*#__PURE__*/ _jsx(App, {})
        })
    })
}));
